module.exports = __webpack_public_path__ + "img/winston_rd_b1.78ce7f21.jpg";